<template>
    <section
        v-if="doc"
        class="section relative"
        :class="sectionClass"
        :style="
      backgroundImage
        ? 'background-image: url(' + backgroundImage.src + ')'
        : ''
    "
        :uk-parallax="parallax"
    >
        <div
            class="inverse"
            v-if="backgroundImage"
        >
            <div
                class="overlay"
                :style="'opacity:' + doc.overlay_opacity / 100"
            ></div>
        </div>
        <div
            class="relative elements"
            v-if="doc.elements || doc.headline"
        >
            <div
                v-if="doc.headline"
                class="-mb-8 ms-3 lg:ms-5"
            >
                <div
                    class="font-handwritten tracking-wider h1 text-center"
                    :class="isDark ? 'text-gray-100' : 'text-gray-700'"
                >
                    {{ doc.headline }}
                </div>
            </div>
            <template v-for="(element, index) in doc.elements">
                <section-text
                    v-if="element.type == 'text'"
                    :key="index"
                    :doc="element"
                />

                <slideshow
                    v-if="element.type == 'slideshow'"
                    :key="index"
                    :doc="element"
                />

                <cards
                    v-if="element.type == 'karten'"
                    :key="index"
                    :doc="element"
                />

                <gallery
                    v-if="element.type == 'galerie'"
                    :key="index"
                    :doc="element"
                />
            </template>
        </div>
        <div
            v-if="doc.divider"
            class="section-divider container"
        >

        </div>
    </section>
</template>
<script>
import SectionText from "@/components/SectionText";
import Slideshow from "@/components/Slideshow";
import Cards from "@/components/Cards";
import Gallery from "@/components/Gallery";

export default {
    props: ["id", "index"],

    components: {
        SectionText,
        Slideshow,
        Cards,
        Gallery
    },

    data() {
        return {
            doc: null,
            backgroundImage: null
        };
    },

    computed: {
        isDark() {
            return (
                ["primary", "secondary"].indexOf(this.doc.background_color) > -1
            );
        },
        parallax() {
            return this.doc.parallax_effect ? "bgy: -250" : "";
        },
        sectionClass() {
            var className = "";

            className +=
                " " +
                {
                    primary: "bg-primary",
                    secondary: "bg-secondary",
                    muted: "bg-100"
                }[this.doc.background_color];

            return className;
        }
    },

    methods: {
        update() {
            this.$id(this.id, doc => {
                this.doc = doc;

                this.$asset(
                    {
                        src: doc.background_image,
                        w: 1920,
                        h: 1080,
                        fit: "crop_focal"
                    },
                    response => {
                        this.backgroundImage = response;
                    }
                );

                if (this.index === 0 && this.isDark) {
                    $("body").addClass("inverse-header");
                }

                console.log("section");
                console.log(this);
            });
        }
    },

    mounted() {
        this.update();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/PageSection.vue